import { usePostHog } from "posthog-js/react";
import { useEffect, useMemo } from "react";
import useQueryParams from "./useQueryParams";

export const useCheckIsABTest = (key: string, isSend?: boolean) => {
    const { abtest = "" } = useQueryParams();
    const posthog = usePostHog();
    if (abtest === "true") {
        posthog.featureFlags.overrideFeatureFlags({ flags: { [key]: "test" } });
    }
    const variant = posthog.getFeatureFlag(key, { send_event: Boolean(isSend) });

    // useEffect(() => {
    //     posthog.reloadFeatureFlags();
    // }, []);

    // useEffect(() => {
    //     if (abtest === "true") {
    //         posthog.featureFlags.overrideFeatureFlags({
    //             flags: { [key]: "test" },
    //         });
    //     } else {
    //         posthog.featureFlags.overrideFeatureFlags({ flags: {} });
    //     }
    // }, [abtest, key, posthog]);

    const isABTest = useMemo(() => {
        return variant === "test";
    }, [variant]);

    return isABTest;
};
